import Grid from "@mui/material/Unstable_Grid2";
import React, { Component } from "react";
import "./Mydocuments.scss";
import ErrorIcon from "@mui/icons-material/Error";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import {
  Box,
  Button,
  Link,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  TextField,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import SlidingPanel from "react-sliding-side-panel";
import SelectDropdown from "../../../../Supporting files/SelectDropdown/SelectDropdown";
interface Props {
  attrName: any;
  open_status: boolean;
  value_update: Function;
}

const Mydocuments: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
}) => {
  const [gender, setGender] = React.useState("");
  const [maritalStatus, setMaritalStatus] = React.useState("");
  const [relation, setRelation] = React.useState("");
  const [selectDocument, setSelectDocument] = React.useState("");
  const [age, setAge] = React.useState("");
  const [insurer, setInsurer] = React.useState("");
  const [kycDocumentStatus, setKycDocumentStatus] = React.useState("kyc");
  const [PolicyName, setPolicyName] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [warnUploadDocument, setWarnUploadDocument] = React.useState(false);
  const [addMemberStatus, setAddMemberStatus] = React.useState(false);
  const [pageStatus, setPageStatus] = React.useState<number>(1);
  const handleChange = (event: SelectChangeEvent, attrName: string) => {
    if (attrName === "gender") {
      setGender(event.target.value as string);
    } else if (attrName === "maritalStatus") {
      setMaritalStatus(event.target.value as string);
    } else if (attrName === "relation") {
      setRelation(event.target.value as string);
    } else if (attrName === "age") {
      setAge(event.target.value as string);
    } else if (attrName === "selectDocument") {
      setSelectDocument(event.target.value as string);
    }
  };
  let PolicyName_data = [
    { key: "Jeevan Bima Health Plan", value: "Jeevan Bima Health Plan" },
    { key: "Star Health Plan", value: "Star Health Plan" },
    { key: "New Health Insurance", value: "New Health Insurance" },
  ];
  let selectDocument_data = [
    { key: "Aadhar Card", value: "Aadhar Card" },
    { key: "Driving Licence", value: "Driving Licence" },
    { key: "Passport", value: "Passport" },
  ];
  let insurer_data = [
    { key: "Aadhar Card", value: "Aadhar Card" },
    { key: "Driving Licence", value: "Driving Licence" },
    { key: "Passport", value: "Passport" },
  ];
  const changePageStatus = (status: boolean) => {
    if (status === true) {
      if (pageStatus < 2) {
        setPageStatus(pageStatus + 1);
      }
    } else {
      if (pageStatus > 1) {
        setPageStatus(pageStatus - 1);
      }
    }
  };
  const updateMasterState = (
    attrName: any,
    value: string | boolean | number
  ) => {
    attrName(value);
  };
  return (
    <Grid container spacing={3} className="mydocuments">
      {/* <Modal
        open={addMemberStatus}
        
        className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Link  className="close-button" onClick={() => {
                  setAddMemberStatus(false);
                }}></Link>
              <h5 className="popup-heading">Upload Documents</h5>
            </Grid>
          </Grid>
          <Grid container spacing={3} className="mb-3">
            <Grid item xs={12}>
              <div className="selector width-per-item">
                <Button
                  className={kycDocumentStatus === "kyc" ? "selection" : ""}
                  style={{ color: "#000" }}
                  onClick={() => {
                    setKycDocumentStatus("kyc");
                  }}
                >
                  KYC Document
                </Button>
                <Button
                  className={kycDocumentStatus === "policy" ? "selection" : ""}
                  style={{ color: "#000" }}
                  onClick={() => {
                    setKycDocumentStatus("policy");
                  }}
                >
                  Policy Document
                </Button>
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={3} justifyContent="center" className="mb-3">
            {kycDocumentStatus == "policy" ? (
              <Grid item xs={12} className="inputField">
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Policy Name
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={relation}
                    label="Relationship"
                    onChange={(e) => handleChange(e, "relation")}
                  >
                    <MenuItem value={"b"}>Brother</MenuItem>
                    <MenuItem value={"s"}>Sister</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            ) : (
              <Grid item xs={12} className="inputField">
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Select Document
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={selectDocument}
                    label="selectDocument"
                    onChange={(e) => handleChange(e, "selectDocument")}
                  >
                    <MenuItem value={"aadhar"}>Aadhar Card</MenuItem>
                    <MenuItem value={"pan"}>PAN</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            )}
            {kycDocumentStatus == "policy" ? (
              <Grid item xs={12} className="inputField">
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Select Insurer
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={relation}
                    label="Relationship"
                    onChange={(e) => handleChange(e, "relation")}
                  >
                    <MenuItem value={"i"}>ICICI</MenuItem>
                    <MenuItem value={"h"}>HDFC</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            ) : null}
          </Grid>
          <Grid container spacing={0} className="mb-4">
            <Grid item xs={10} className="inputField uploadFile">
              <TextField
                fullWidth
                id="outlined-basic"
                label="Upload Document"
                className="textarea"
              />
            </Grid>
            <Grid item xs={2}>
              <Button className="browsebtn">Browse</Button>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid
              item
              xs={12}
              className="ctaBtn"
              style={{ textAlign: "center" }}
            >
              <Button className="submitBtn">Submit Details</Button>
            </Grid>
          </Grid>
        </Box>
      </Modal> */}
      <SlidingPanel
        type={"right"}
        isOpen={addMemberStatus}
        size={75}
        panelClassName="slidingPanel"
        backdropClicked={() => setAddMemberStatus(false)}
      >
        <Box className={open_status == true ? "modalInner show" : "modalInner"}>
          <Grid container spacing={3} alignItems="center">
            <Grid xs={9}>
              <h4 className="mb-0 mt-3 text-left">Upload Documents</h4>
            </Grid>
            <Grid xs={3}>
              <Link
                className="close-button"
                onClick={() => {
                  setAddMemberStatus(false);
                }}
              />
            </Grid>
          </Grid>

          <div className="scrollable_area">
            <Grid container spacing={3} className="mt-0">
              <Grid xs={12}>
                <div className="selector width-per-item">
                  <Button
                    className={kycDocumentStatus === "kyc" ? "selection" : ""}
                    style={{ color: "#000" }}
                    onClick={() => {
                      setKycDocumentStatus("kyc");
                    }}
                  >
                    KYC Document
                  </Button>
                  <Button
                    className={
                      kycDocumentStatus === "policy" ? "selection" : ""
                    }
                    style={{ color: "#000" }}
                    onClick={() => {
                      setKycDocumentStatus("policy");
                    }}
                  >
                    Policy Document
                  </Button>
                </div>
              </Grid>
              {kycDocumentStatus == "policy" ? (
                <Grid xs={12}>
                  <SelectDropdown
                    class_name="inputField"
                    title="Policy Name"
                    attrName={setPolicyName}
                    value={PolicyName}
                    value_update={updateMasterState}
                    dropdown_data={PolicyName_data}
                  />
                </Grid>
              ) : (
                <Grid xs={12}>
                  <SelectDropdown
                    class_name="inputField"
                    title="Select Document"
                    attrName={setSelectDocument}
                    value={selectDocument}
                    value_update={updateMasterState}
                    dropdown_data={selectDocument_data}
                  />
                </Grid>
              )}
              {kycDocumentStatus == "policy" ? (
                <Grid xs={12}>
                  <SelectDropdown
                    class_name="inputField"
                    title="Insurer"
                    attrName={setInsurer}
                    value={insurer}
                    value_update={updateMasterState}
                    dropdown_data={insurer_data}
                  />
                </Grid>
              ) : null}

              <Grid xs={12}>
                <Grid
                  container
                  spacing={0}
                  justifyContent="center"
                  className="mb-5 p-0"
                >
                  <Grid xs={10} className="inputField uploadFile">
                    <TextField
                      fullWidth
                      id="outlined-basic"
                      label="Select file"
                      variant="outlined"
                      className="textarea"
                    />
                  </Grid>
                  <Grid xs={2}>
                    <Button variant="contained" className="browsebtn">
                      Browse
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>

          <Grid container spacing={2}>
            <Grid
              xs={12}
              style={{ textAlign: "center", position: "relative" }}
              className="ctaBtn"
            >
              <Button
                variant="contained"
                className="submitBtn fixedbtn"
                onClick={() => {
                  changePageStatus(true);
                }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Box>
      </SlidingPanel>
      <Grid xs={6}>
        <h3 className="mb-0">My Documents</h3>
      </Grid>
      <Grid xs={6} className="text-right">
        <Link
          className="blueBtn upload"
          underline="none"
          onClick={() => {
            setAddMemberStatus(true);
          }}
        >
          Upload Documents
        </Link>
      </Grid>

      <Grid xs={12} sx={{ paddingLeft: "0px" }}>
        <Grid container spacing={3}>
          <Grid xs={12}>
            <h5 className="font-medium mb-0">KYC Documents</h5>
          </Grid>
          <Grid xs={12} className="allDocs">
            <div className="docCard">
              <img src="./images/doc_check_icon.svg" height="30px" alt="doc" />
              <p>Aadhar</p>
              <div className="icons">
                <Link underline="none">
                  <VisibilityOutlinedIcon sx={{ color: "#000000" }} />
                </Link>
                <Link underline="none">
                  <FileDownloadOutlinedIcon sx={{ color: "#2166AA" }} />
                </Link>
                <Link underline="none">
                  <DeleteForeverOutlinedIcon sx={{ color: "#EB5757" }} />
                </Link>
              </div>
            </div>
            <div className="docCard">
              <img src="./images/doc_check_icon.svg" height="30px" alt="doc" />
              <p>PAN</p>
              <div className="icons">
                <Link underline="none">
                  <VisibilityOutlinedIcon sx={{ color: "#000000" }} />
                </Link>
                <Link underline="none">
                  <FileDownloadOutlinedIcon sx={{ color: "#2166AA" }} />
                </Link>
                <Link underline="none">
                  <DeleteForeverOutlinedIcon sx={{ color: "#EB5757" }} />
                </Link>
              </div>
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid xs={12}>
            <h5 className="font-medium mb-0">My Policy Documents</h5>
          </Grid>
          <Grid
            container
            alignItems="center"
            xs={12}
            sx={{ MarginLeft: "0px" }}
          >
            <ErrorIcon sx={{ color: "#EB5757" }} /> &nbsp;&nbsp;
            <p className="fontMontserrat font-sm font-medium">
              No policy document uploaded.
            </p>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Mydocuments;
